export enum EMaintenanceStatusType {
  ACTIVE = 'ACTIVE',
  SCHEDULED = 'SCHEDULED',
  INACTIVE = 'INACTIVE',
}
